// extracted by mini-css-extract-plugin
export default {"overflowLabel":"widgets-business-banking-styles-ListRowContent__overflowLabel--XTVbj","listRowContent":"widgets-business-banking-styles-ListRowContent__listRowContent--jKrVq"};